import React, { useEffect, useState } from "react";
import "./style.css";

const CountdownTimer = ({ createdAt }) => {
  const totalSeconds = 12 * 60 * 60; // 12 hours in seconds

  const [remaining, setRemaining] = useState(getTimeRemaining());

  function getTimeRemaining() {
    const created = new Date(createdAt);
    const target:any = new Date(created.getTime() + totalSeconds * 1000);
    const now:any = new Date();
    const diff = Math.max(0, Math.floor((target - now) / 1000));
    return {
      total: diff,
      hours: Math.floor(diff / 3600),
      minutes: Math.floor((diff % 3600) / 60),
      seconds: diff % 60,
    };
  }

  useEffect(() => {
    const timer = setInterval(() => {
      setRemaining(getTimeRemaining());
    }, 1000);
    return () => clearInterval(timer);
  }, [createdAt]);

  const getProgress = (value: number, max: number) =>
    141.3 - (141.3 * value) / max; // 141.3 is stroke length for radius 20 (2πr)

  const renderCircle = (label: string, value: number, max: number) => (
    <div className="progress-ring">
      <svg className="ring" width="60" height="60">
        <circle className="ring-bg" cx="30" cy="30" r="22" />
        <circle
          className="ring-progress"
          cx="30"
          cy="30"
          r="22"
          strokeDasharray="141.3"
          strokeDashoffset={getProgress(value, max)}
        />
        <text x="30" y="-29" textAnchor="middle" className="ring-value">
          {String(value).padStart(2, "0")}
        </text>
      </svg>
      <p className="ring-label">{label}</p>
    </div>
  );

  return (
    <div className="countdown-container">
      <p className="confirm-label">CONFERMA ENTRO</p>
      <div className="countdown-circles">
        {renderCircle("Hours", remaining.hours, 12)}
        {renderCircle("Minutes", remaining.minutes, 60)}
        {renderCircle("Seconds", remaining.seconds, 60)}
      </div>
    </div>
  );
};

export default CountdownTimer;
